export class VenueRequestContractError extends Error {
  constructor(detail) {
    super(`Invalid venue policy request: ${detail}`);
    this.name = 'VenueRequestContractError';
    this.code = 'INVALID_API_REQUEST';
  }
}

const activityPolicies = new Set(['devotional', 'junioryouth', 'childrensclass', 'studycircle', 'fireside', 'initiative']);
const eventPolicies = new Set(['feast', 'holyday', 'training', 'communitymeeting', 'infonight', 'youthevent']);
const isPolicyList = (value, allowed) => Array.isArray(value)
  && value.every(item => typeof item === 'string'
    && (!item.trim() || allowed.has(item.trim().toLowerCase())));

/** Preserve partial and legacy case-insensitive policy updates for the backend. */
export function readVenuePolicyRequest(policy) {
  if (!policy || typeof policy !== 'object' || Array.isArray(policy)
    || (policy.activities !== undefined && !isPolicyList(policy.activities, activityPolicies))
    || (policy.events !== undefined && !isPolicyList(policy.events, eventPolicies))) {
    throw new VenueRequestContractError('expected optional activity and event policy arrays with supported values.');
  }
  return { policy };
}
